import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initMonitoring } from './lib/monitoring';

initMonitoring(); // Sentry (no-op se REACT_APP_SENTRY_DSN non è configurata)

// Cintura di sicurezza privacy: in produzione i log informativi sono no-op
// a livello globale (i file sensibili usano già devLog, questo copre tutto
// il resto del codice e le dipendenze). console.warn/error restano attivi.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
  // eslint-disable-next-line no-console
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker per le Web Push (fine recupero). Non fa caching: l'app carica
// sempre la build fresca. La registrazione all'avvio tiene il worker aggiornato.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
